import { MainChart } from "./types";

export const DEFAULT_MAIN_CHART: MainChart = {
  id: "main",
  volumes: false,
  tickVolumes: false,
  askPriceLine: false,
  periodSeparators: false,
  countdownToBarClose: false,
  tradeOrders: false,
  tradePositions: false,
  slTpLevels: false,
  tradeHistory: false,
  preloadChartsData: false,
};
